import { createSelector } from 'reselect';

import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import { TState } from '~/src/store';

const getSubscriptionsWithConditions = createSelector(
    [
        selectCurrentTariff,
        (state: TState) => state.fullBuy.subscriptions,
        (state: TState) => state.fullBuy.selectedSubscriptions,
    ],
    (tariff, subscriptions, selectedSubscriptions) => {

        if (tariff && subscriptions && tariff.sale_package_id in subscriptions) {
            const needToSelect = Number(tariff?.subscriptionsSummary?.find(s => tariff.speed === s.speed)?.cnt || 1);
            const leftToSelect = needToSelect - selectedSubscriptions.length;

            return {
                subscriptions: subscriptions[tariff.sale_package_id].items,
                selected: selectedSubscriptions,
                needToSelect,
                leftToSelect,
                tariffName: tariff.tariff_name,
            };
        } else {
            return {
                subscriptions: [],
                selected: [],
                needToSelect: 0,
                leftToSelect: 0,
                tariffName: '',
            };
        }
    },
);

export default getSubscriptionsWithConditions;
